import { render, staticRenderFns } from "./HealthyMetersChart.vue?vue&type=template&id=22b97631&scoped=true"
import script from "./HealthyMetersChart.vue?vue&type=script&lang=js"
export * from "./HealthyMetersChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b97631",
  null
  
)

export default component.exports